<style scoped lang="scss"></style>

<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" getUrl="/custom/weier/rework/order/page" ref="yt" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('fanxiudanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>

          <el-form-item :label="$t('jianyandanhao')">
            <el-input v-model="yt.conditions.inspectionRecordNo"></el-input>
          </el-form-item>

          <el-form-item :label="$t('shebeimingcheng')" rexiauired>
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIds"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIds"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('danjuzhuangtai')">
            <yi_dictionary_select type="REWORK_ORDER_STATUS" :ids.sync="yt.conditions.status"></yi_dictionary_select>
          </el-form-item>

          <el-form-item :label="$t('biaoqiantiaoma')">
            <el-input v-model="yt.conditions.labelCode"></el-input>
          </el-form-item>

          <el-button @click="yt.get(1)" type="primary" plain size="mini">
            {{ $t('sousuo') }}
          </el-button>
          <el-button @click="yt.clear()" size="mini">{{ $t('chongzhi') }}</el-button>

          <yi_curd_expand_button></yi_curd_expand_button>
        </el-form>
      </template>
      <template #buttonsR>
        <el-button :loading="rework_order_export_loading" size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
      </template>

      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-button size="mini" type="text" @click="yt.showEditDialog('biaoqianmingxi', scope.row, '1300px')">
            {{ $t('biaoqianmingxi') }}
          </el-button>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'biaoqianmingxi'">
        <div class="dialog-scroller">
          <labelDetail :reWorkOrderId="yt.editObj.id"></labelDetail>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import labelDetail from './label_details';

export default {
  name: 'web_rework_order_list',
  components: {
    labelDetail
  },
  data() {
    return {
      rework_order_export_loading: false,
      statusMap: {
        0: '未处理',
        1: '处理中',
        2: '处理完成'
      },
      columns: [
        {
          prop: 'no',
          label: 'fanxiudanhao'
        },
        {
          prop: 'inspectionRecordNo',
          label: 'jianyandanhao'
        },
        {
          prop: 'inspectionType',
          label: 'jianyanleixing',
          type: 'dictionary',
          key: 'QUALITY_INSPECTION_TYPE'
        },
        {
          prop: 'equipment.name',
          label: 'shebeimingcheng'
        },
        {
          prop: 'material.code',
          label: 'chanpinbianma'
        },
        {
          prop: 'material.name',
          label: 'chanpinmingcheng'
        },
        {
          prop: 'num',
          label: 'shuliang'
        },
        {
          prop: 'status',
          label: 'danjuzhuangtai',
          type: 'dictionary',
          key: 'REWORK_ORDER_STATUS'
        },
        {
          label: 'caozuo',
          type: 'slot'
        }
      ]
    };
  },
  methods: {
    exportExcel() {
      this.weight_info_export_loading = true;
      //查询表格
      this.http
        .get('/custom/weier/rework/order/page?page=1&limit=10000', { params: { ...this.yt.conditions } })
        .then(res => {
          let tableFirst = this.columns.map(i => {
            if (i.label != 'caozuo') {
              return this.$t(i.label);
            }
          });
          let tableData = [];
          tableData.push(tableFirst);
          let listData = res.data.rows;
          for (let i = 0; i < listData.length; i++) {
            let dataArr = this.getTableDataArr(listData[i]);
            tableData.push(dataArr);
          }
          console.log('tableArr', tableData);
          const worksheet = XLSX.utils.aoa_to_sheet(tableData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
          XLSX.writeFile(workbook, `返修单-${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
        })
        .finally(() => {
          this.weight_info_export_loading = false;
        });
    },
    getTableDataArr(row) {
      console.log(row);
      let dataArr = [];
      dataArr[0] = row.no;
      dataArr[1] = row.inspectionRecordNo;
      dataArr[2] = row.inspectionType;
      dataArr[3] = row.equipment ? row.equipment.name : '';
      dataArr[4] = row.material ? row.material.code : '';
      dataArr[5] = row.material ? row.material.name : '';
      dataArr[6] = row.num;
      dataArr[7] = row.status ? this.statusMap[row.status] : '';
      return dataArr;
    }
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  }
};
</script>
